import { useState } from "react";
import { Layout } from "antd";
import ToDoMenu from "./ToDoMenu";
import ToDoFilters from "./ToDoFilters";
const { Sider } = Layout;

const ToDoSider = (props) => {
  const {
    changeContentTitle,
    filters,
    onChangeFilters,
    onChangeMenuFilter,
    onCollapse,
    collapsed,
  } = props;

  return (
    <Sider
      width={200}
      style={{
        background: "#ffffff",
        borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
      }}
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      // onCollapse={(value) => setCollapsed(value)}
    >
      <ToDoMenu onChangeMenuFilter={onChangeMenuFilter} filters={filters} />
      <div className="sidebar-seperator" />
      {!collapsed && (
        <ToDoFilters
          changeContentTitle={changeContentTitle}
          filters={filters}
          changeFilters={onChangeFilters}
        />
      )}
    </Sider>
  );
};

export default ToDoSider;
